<template>
  <v-container fluid class="termos-page pa-0">

    <!-- HEADER -->
    <div class="termos-header">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8" class="text-center">
            <div class="termos-label">DOCUMENTO LEGAL</div>
            <h1 class="termos-title">Termos de Serviço</h1>
            <p class="termos-updated">Última atualização: abril de 2026</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- CONTEÚDO -->
    <v-container class="py-12">
      <v-row justify="center">
        <v-col cols="12" md="8">
          <div class="termos-body">

            <section class="termos-section">
              <h2 class="sec-title">1. Aceitação dos Termos</h2>
              <p>
                Ao acessar ou utilizar o sistema <strong>CargasZap</strong>, você declara ter lido, compreendido
                e concordado integralmente com estes Termos de Serviço. Caso não concorde com qualquer
                disposição aqui prevista, recomendamos que não utilize a plataforma.
              </p>
              <p>
                O uso continuado do sistema após eventuais alterações nos presentes termos implica
                aceitação tácita das novas condições.
              </p>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">2. Descrição do Serviço</h2>
              <p>
                O CargasZap é uma plataforma de gestão operacional e financeira voltada para
                transportadoras, oferecendo recursos como:
              </p>
              <ul>
                <li>Cadastro e controle de motoristas e veículos;</li>
                <li>Controle financeiro com lançamento de despesas via WhatsApp;</li>
                <li>Alertas automáticos de vencimento de documentos via WhatsApp;</li>
                <li>Diário de bordo digital;</li>
                <li>Dashboard operacional;</li>
                <li>Nos planos personalizados: lançamento de CT-e e Manifestos.</li>
              </ul>
              <p>
                O sistema é disponibilizado mediante contratação de plano, conforme descrito na página
                de planos. A empresa prestadora reserva-se o direito de alterar, expandir ou descontinuar
                funcionalidades mediante aviso prévio.
              </p>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">3. Cadastro e Conta do Usuário</h2>
              <p>
                Para utilizar o sistema, é necessário criar uma conta com informações verídicas e
                atualizadas. O usuário é o único responsável pela confidencialidade de seus dados de
                acesso (login e senha) e por todas as ações realizadas em sua conta.
              </p>
              <p>
                Qualquer acesso não autorizado deve ser comunicado imediatamente ao suporte. A
                empresa não se responsabiliza por danos decorrentes do uso indevido das credenciais
                pelo próprio usuário ou por terceiros.
              </p>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">4. Responsabilidades do Usuário</h2>
              <p>O usuário se compromete a:</p>
              <ul>
                <li>Fornecer informações corretas e atualizadas no cadastro;</li>
                <li>Utilizar o sistema exclusivamente para fins lícitos e relacionados à gestão de sua transportadora;</li>
                <li>Não compartilhar o acesso com pessoas não autorizadas;</li>
                <li>Não tentar acessar dados de outros usuários ou sistemas;</li>
                <li>Não utilizar o sistema para envio de conteúdo ilegal, ofensivo ou spam;</li>
                <li>Manter seus dados de pagamento em dia para não interromper o acesso.</li>
              </ul>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">5. Limitação de Responsabilidade</h2>
              <p>
                O CargasZap é uma ferramenta de apoio à gestão. A empresa prestadora <strong>não se
                responsabiliza</strong> por:
              </p>
              <ul>
                <li>Decisões operacionais, financeiras ou fiscais tomadas com base nas informações
                  geradas pelo sistema;</li>
                <li>Erros de digitação, dados incorretos inseridos pelo próprio usuário ou motoristas;</li>
                <li>Multas, autuações ou prejuízos decorrentes de documentos vencidos, mesmo que o
                  sistema tenha enviado alertas;</li>
                <li>Interrupções temporárias por manutenção, falhas de infraestrutura de terceiros (servidores,
                  WhatsApp, internet) ou casos de força maior;</li>
                <li>Integração com sistemas fiscais ou obrigações acessórias perante a Fazenda Pública.</li>
              </ul>
              <p>
                O sistema é oferecido no estado em que se encontra (<em>as-is</em>). A empresa envidará
                esforços razoáveis para manter o funcionamento correto, mas não garante disponibilidade
                ininterrupta.
              </p>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">6. Pagamento e Cancelamento</h2>
              <p>
                Os planos são cobrados conforme periodicidade contratada (mensal ou anual). O não
                pagamento na data de vencimento poderá acarretar suspensão ou cancelamento do acesso,
                sem direito a reembolso proporcional dos dias não utilizados.
              </p>
              <p>
                O usuário pode solicitar o cancelamento a qualquer momento pelo suporte. O acesso
                permanece ativo até o fim do período já pago. Não são realizados estornos por
                cancelamento antecipado.
              </p>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">7. Propriedade Intelectual</h2>
              <p>
                Todo o conteúdo do sistema — incluindo código-fonte, layout, logotipos, textos e
                funcionalidades — é de propriedade exclusiva da empresa desenvolvedora e está protegido
                pela legislação de propriedade intelectual vigente no Brasil.
              </p>
              <p>
                É vedado ao usuário copiar, reproduzir, distribuir, modificar ou criar trabalhos
                derivados sem autorização expressa e por escrito.
              </p>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">8. Privacidade e Proteção de Dados</h2>
              <p>
                O tratamento de dados pessoais é realizado em conformidade com a
                <strong>Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)</strong>.
                Os dados coletados são utilizados exclusivamente para a prestação dos serviços
                contratados e não são vendidos ou compartilhados com terceiros, salvo por obrigação
                legal ou para o funcionamento da plataforma (ex.: envio de mensagens via WhatsApp).
              </p>
              <p>
                O usuário pode solicitar a exclusão de seus dados a qualquer momento pelo suporte,
                observados os prazos legais de retenção. Para mais detalhes sobre o tratamento de
                dados, consulte nossa
                <router-link to="/politica-de-privacidade" class="politica-link">Política de Privacidade</router-link>.
              </p>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">9. Alterações nos Termos</h2>
              <p>
                Estes Termos podem ser atualizados periodicamente. Alterações relevantes serão
                comunicadas por e-mail ou notificação dentro do sistema com antecedência mínima de
                15 (quinze) dias. O uso continuado após esse prazo implica aceitação das novas condições.
              </p>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">10. Foro e Legislação Aplicável</h2>
              <p>
                Estes Termos são regidos pelas leis da República Federativa do Brasil. Para dirimir
                quaisquer controvérsias decorrentes deste instrumento, as partes elegem o foro da
                comarca da sede da empresa, com renúncia expressa a qualquer outro, por mais
                privilegiado que seja.
              </p>
            </section>

            <v-divider class="termos-divider" />

            <section class="termos-section">
              <h2 class="sec-title">11. Contato</h2>
              <p>
                Para dúvidas, solicitações ou reclamações relacionadas a estes Termos, entre em contato
                pelo WhatsApp ou pelo e-mail disponível no site.
              </p>
            </section>

          </div>
        </v-col>
      </v-row>
    </v-container>

  </v-container>
</template>

<script>
export default {
  name: "TermosPage"
};
</script>

<style scoped>
.termos-page {
  background: radial-gradient(circle at top left, #0f172a, #020617);
  min-height: 100vh;
  color: #f1f5f9;
  font-family: "Inter", sans-serif;
}

.termos-header {
  background: linear-gradient(180deg, #0b1220 0%, transparent 100%);
  padding: 80px 0 48px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.termos-label {
  color: #10b981;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 12px;
}

.termos-title {
  font-size: 42px;
  font-weight: 800;
  color: #f1f5f9;
  margin-bottom: 10px;
}

.termos-updated {
  color: #64748b;
  font-size: 13px;
}

.termos-body {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 48px 52px;
}

.termos-section {
  margin-bottom: 8px;
}

.sec-title {
  font-size: 17px;
  font-weight: 700;
  color: #10b981;
  margin-bottom: 14px;
}

.termos-body p {
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: 10px;
}

.termos-body ul {
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.8;
  padding-left: 20px;
  margin-bottom: 10px;
}

.termos-body ul li {
  margin-bottom: 6px;
}

.termos-body strong {
  color: #f1f5f9;
}

.politica-link {
  color: #10b981;
  font-weight: 500;
  text-decoration: none;
}

.politica-link:hover {
  color: #0ea371;
  text-decoration: underline;
}

.termos-divider {
  border-color: rgba(255, 255, 255, 0.06) !important;
  margin: 28px 0;
}

@media (max-width: 600px) {
  .termos-body {
    padding: 28px 20px;
  }

  .termos-title {
    font-size: 28px;
  }
}
</style>
